export class PedidosUsuarioResponse {
  httpStatus: number;
  response: {
    id: string;
    codeResponse: string;
    response: string;
    list: any[];   // ✅ importante
  };

  constructor() {
    this.httpStatus = 0;
    this.response = {
      id: '',
      codeResponse: '',
      response: '',
      list: []      // ✅ inicializar vacío
    };
  }
}
